/* import __COLOCATED_TEMPLATE__ from './details.hbs'; */
import Component from '@glimmer/component';

export default class SiteBillingAccountHistoryCellsDetails extends Component {
  get detailsValue() {
    const item = this.args.item;

    switch (item.constructor.modelName) {
      case 'invoice-item':
        return 'product';
      default:
        return item.constructor.modelName;
    }
  }

  get shouldShowBadge() {
    const item = this.args.item;

    return (
      item.constructor.modelName === 'appointment' ||
      item.constructor.modelName === 'group-appointment'
    );
  }
}
